import {
  toLandingPageBlackFridayLink,
  toLandingPageSeasonalLink,
} from 'lib/links';

const BLACK_FRIDAY_PARAM = 'black-friday';

const getCategoryLandingUrl = (categoryOrSubcategory, type, landingSlug) => {
  if (landingSlug === BLACK_FRIDAY_PARAM) {
    return toLandingPageBlackFridayLink(categoryOrSubcategory, type);
  }

  return toLandingPageSeasonalLink(categoryOrSubcategory, type, landingSlug);
};

const normalizeLandingItens = (
  { id, name, slug },
  type,
  landingSlug,
  asPath
) => {
  const href = getCategoryLandingUrl(slug, type, landingSlug);
  return {
    id,
    name,
    slug,
    type,
    href,
    active: asPath === href,
  };
};

export const getCategoriesLandings = (
  landingCategories,
  asPath,
  landingSlug,
  homeLandingItem
) => {
  const allCategories = [
    ...landingCategories.categories.map((category) =>
      normalizeLandingItens(
        {
          id: category.categoryId,
          name: category.categoryName,
          slug: category.categorySlug,
        },
        'category',
        landingSlug,
        asPath
      )
    ),
    ...landingCategories.subcategories.map((subcategory) =>
      normalizeLandingItens(
        {
          id: subcategory.subcategoryId,
          name: subcategory.subcategoryName,
          slug: subcategory.subcategorySlug,
        },
        'subcategory',
        landingSlug,
        asPath
      )
    ),
  ];

  if (!asPath.endsWith(`/${landingSlug}/`)) {
    allCategories.unshift(homeLandingItem);
  }

  const matchedIndex = allCategories.findIndex(({ slug, type }) => {
    const categoryPath = getCategoryLandingUrl(landingSlug, slug, type);
    return asPath === categoryPath;
  });

  if (matchedIndex > -1) {
    const matchedCategory = allCategories[matchedIndex];
    return [
      matchedCategory,
      ...allCategories.filter((_, index) => index !== matchedIndex),
    ];
  }

  return allCategories;
};
